import {
    SuggestAttachingACopySingleText,
    SuggestActionForMultipleFilesCannotShareText,
} from './getActionRecommendations.locstring.json';
import loc from 'owa-localize';
import { InfoBarStringTemplates } from './sharingTipIdToInfoBarString';
import { SharingTipId } from '../../types/sharingTipId';
import { assertNever } from 'owa-assert';

export function getActionRecommendations(
    sharingTipId: SharingTipId
): InfoBarStringTemplates | null {
    switch (sharingTipId) {
        case SharingTipId.noPermissionToShare:
        case SharingTipId.noPermissionToShareExternally:
        case SharingTipId.externalRecipientCSL:
            return {
                singleFile: loc(SuggestAttachingACopySingleText),
                multipleFiles: loc(SuggestActionForMultipleFilesCannotShareText),
            };
        case SharingTipId.getSharingInfoFailed:
        case SharingTipId.linkHasExpired:
        case SharingTipId.linkWillExpire:
        case SharingTipId.noPermissionSet:
        case SharingTipId.sharingWithLargeDL:
            return null;
        default:
            return assertNever(sharingTipId);
    }
}
